import AppBaseStore from './baseStore'
import { useDjango } from '@/composables/useDjango'
import type { BaseStoreActions, BaseStoreType } from '@/types/storeTypes'
import API from '@/api/apiUrls'
import type { BorehoreSampleObservation } from '@/stores/type/borehoreSampleObservation.type'

const { api } = useDjango()

type State = BaseStoreType<BorehoreSampleObservation>

const baseUrl = API.BOREHOLE_DATA.BOREHOLE_SAMPLE_OBSERVATION.INDEX
const baseStore: BaseStoreType<BorehoreSampleObservation> = new AppBaseStore(
  baseUrl,
  api,
  null,
  'id'
)
const baseStoreActions: BaseStoreActions<BorehoreSampleObservation> = baseStore.actions
export const useBoreholeSampleObservationStore = defineStore({
  id: 'boreholeSampleObservation',
  state: (): State => ({
    ...baseStore.state,
    showUploadDialog: false,
    selectedColumns: []
  }),
  actions: {
    ...baseStoreActions,
    resetAll() {
      this.$reset()
    },
    toggleUploadDialog() {
      this.showUploadDialog = !this.showUploadDialog
    },
    async uploadStowaFiles(formData) {
      try {
        this.writeLoading = true
        const response = await api.service(baseUrl).create(formData)
        this.setItems(response)
      } catch (error) {
        this.setSnackbarMessage('Create item failed.', 'error')
        console.error(e)
      } finally {
        this.writeLoading = false
        this.toggleUploadDialog()
      }
    }
  },
  getters: {
    ...baseStore.getters,
    filteredByGIPointId: (state: State) => (giPointId: number) => {
      return state.items.filter((sampleObervation) => sampleObervation.gi_point === giPointId)
    },
    selectableColumns: (state: State) => {
      const mapping = {}
      for (const sampleObservation of state.items) {
        mapping[sampleObservation.parameter_name] = true
      }
      return Object.keys(mapping)
    },
    shownDataByGIPointId: (state: State) => (giPointId: number) => {
      const resultMapping = {}
      const sampleObservations = state.items.filter(
        (sampleObervation) => sampleObervation.gi_point === giPointId
      )
      for (const observation of sampleObservations) {
        if (!(observation.sample_id in resultMapping)) {
          resultMapping[observation.sample_id] = {
            sample_id: observation.sample_id
          }
        }
        resultMapping[observation.sample_id][observation.parameter_name] =
          observation.parameter_value
      }
      return Object.values(resultMapping)
    }
  }
})
